import { useState } from 'react'

function CustomerList({ customers, onSelectCustomer, onGenerateToken }) {
  const [copiedId, setCopiedId] = useState(null)

  const handleCopyLink = (customer) => {
    const url = `${window.location.origin}?v=${customer.viewer_token}`
    navigator.clipboard.writeText(url)
    setCopiedId(customer.id)
    setTimeout(() => setCopiedId(null), 2000)
  }

  const handleOpenInLinear = (customer) => {
    const url = `https://linear.app/xano/customer/${customer.linear_customer_id}`
    window.open(url, '_blank')
  }

  if (!customers || customers.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-xano-textMuted">No customers found</div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {customers.map((customer) => (
        <div
          key={customer.id}
          className="px-6 py-5 bg-xano-card border border-xano-border rounded-lg hover:bg-xano-cardHover transition"
        >
          <div className="flex items-center justify-between">
            {/* Left side: Name and action buttons */}
            <div className="flex items-center gap-3">
              <h3 className="text-xl font-semibold text-xano-text">{customer.name}</h3>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  onSelectCustomer(customer)
                }}
                className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white border border-white/30 hover:bg-white/10 rounded-md transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
                View Requests
              </button>
              {customer.linear_customer_id && (
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    handleOpenInLinear(customer)
                  }}
                  className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-xano-textMuted border border-xano-border hover:bg-white/5 rounded-md transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 100 100"
                  >
                    <path d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z" />
                  </svg>
                  Open in Linear
                </button>
              )}
            </div>

            {/* Right side: Copy/Generate link button */}
            <div>
              {customer.viewer_token ? (
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    handleCopyLink(customer)
                  }}
                  className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-green-400 hover:text-green-300 bg-green-400/10 hover:bg-green-400/20 rounded-md transition"
                >
                  {copiedId === customer.id ? (
                    'Copied!'
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                      Copy Link
                    </>
                  )}
                </button>
              ) : (
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    onGenerateToken(customer.id)
                  }}
                  className="px-3 py-1.5 text-sm font-medium text-blue-400 hover:text-blue-300 bg-blue-400/10 hover:bg-blue-400/20 rounded-md transition"
                >
                  Generate Link
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CustomerList
